<template>
  <div class="dark:bg-ontick-carbon-500 relative z-40 space-y-4 bg-gray-50 px-6 py-4 sm:sticky sm:top-0">
    <template v-if="!loading">
      <div class="flex flex-col items-center space-y-4 sm:flex-row sm:items-end sm:justify-between">
        <div class="bg-ontick-steel-400 rounded-lg px-6 py-2 dark:bg-transparent dark:px-0 dark:py-0">
          <img
            :src="data.partner_logo"
            :alt="data.extension_owner"
            class="h-[80px] w-full max-w-[400px] sm:max-h-full"
          />
        </div>
        <div class="flex items-center justify-end space-x-4">
          <template v-for="network in Object.keys(socialMedia)">
            <a v-if="socialMedia[network]" :key="network" :href="socialMedia[network]" rel="noopener noreferrer">
              <img :src="`/img/${network}.png`" :alt="imageAlts(network)" />
            </a>
          </template>
        </div>
      </div>
      <div class="flex flex-col items-center space-y-4 sm:flex-row sm:justify-between sm:space-x-4 sm:space-y-0">
        <p class="w-full max-w-[700px] text-sm text-gray-500 dark:dark:text-gray-400">
          {{ data.extension_desc }}
        </p>
        <ontick-button
          :color="data.active_for_user ? 'transparent' : 'secondary'"
          @click.native="scrollToPlans()"
          :disabled="data.active_for_user"
          class="hidden sm:block"
        >
          <span class="font-bold uppercase">
            {{ data.active_for_user ? "Ativo" : data.extension_price === 0 ? "Ativar extensão" : "Assinar extensão" }}
          </span>
        </ontick-button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },

  computed: {
    socialMedia() {
      return {
        facebook: this.data.partner_facebook,
        instagram: this.data.partner_instagram,
        linkedin: this.data.partner_linkedin,
        telegram: this.data.partner_telegram,
        twitter: this.data.partner_twitter,
        whatsapp: this.data.partner_whatsapp,
        youtube: this.data.partner_youtube,
      };
    },
    loading() {
      return Object.keys(this.data).length === 0;
    },
  },

  methods: {
    imageAlts(network) {
      return (
        network &&
        `${
          network === "youtube"
            ? "YouTube"
            : network === "linkedin"
              ? "LinkedIn"
              : network.charAt(0).toUpperCase() + network.slice(1)
        } de ${this.data.extension_owner}`
      );
    },
    subscribe(id) {
      // console.log("extension_id", id);
    },
    scrollToPlans() {
      const plans = document.getElementById("plans");
      plans.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style></style>
